import { LoadableAfterPaint } from '@confluence/loadable';

export {
	ISSUE_CREATE_SIDE_PANEL_ID,
	ISSUE_CREATE_SIDE_PANEL_WIDTH,
} from './ui/single-work-create/IssueCreateSidePanel';
export {
	BULK_ISSUE_CREATE_SIDE_PANEL_ID,
	BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH,
} from './ui/bulk-work-create-common/BulkCreateSidePanel';

export {
	getValidRange,
	getPageContentRange,
	constructInsertStorageFragmentRequestPayload,
	constructInsertStorageColumnTableRequestPayload,
} from './services/issueInsertionUtils';

export { getClosestTableFromSelection, mapTableToIssues } from './utils/tableUtils';

export { useIsAIIssueCreationEnabled } from './utils/useIsAIIssueCreationEnabled';

export { getPageMode } from './utils/pageModeUtils';

export {
	useBulkCreateLoggingEvents,
	AI_BULK_ISSUE_CREATE_FEATURE_NAME,
} from './utils/useBulkCreateLoggingEvents';

export {
	type IssueCreateSidePanelContextType,
	type IssueCreateSidePanelActions,
	PageMode,
	useIssueCreateSidePanelContext,
} from './providers/IssueCreateSidePanelContextProvider';

export {
	type BulkIssuesListType,
	useSetIsCreatedWithAi,
	useSetIsCreatedFromTable,
	useSetInsertStorageFragmentRequestPayload,
	useSetContentLastModifiedTimestamp,
	useGetContentLastModifiedTimestamp,
} from './providers/BulkCreateContextProvider';

export { useBulkCreateContext } from './providers/BulkCreateContextProvider';

export { type InsertStorageFragmentRequestPayload } from '../src/__types__/InsertStorageFragmentRequestPayload';
export { type InsertStorageColumnTableRequestPayload } from '../src/__types__/InsertStorageColumnTableRequestPayload';

export const IssueCreateSidePanel = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-IssueCreateSidePanel" */ './ui/single-work-create/IssueCreateSidePanel'
			)
		).IssueCreateSidePanel,
});

export const BulkCreateSidePanel = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkCreateSidePanel" */ './ui/bulk-work-create-common/BulkCreateSidePanel'
			)
		).BulkCreateSidePanel,
});

export { IssueCreateWarningDialog } from './ui/work-create-common/IssueCreateWarningDialog';
export {
	useIsWarningDialogOpen,
	useWarningDialogStateActions,
	WarningDialog,
} from './providers/IssueCreateWarningDialogContextProvider';
export { SingleIssueCreateProvidersWrapper } from './providers/SingleIssueCreateProvidersWrapper';
export { BulkIssueCreateProvidersWrapper } from './providers/BulkIssueCreateProvidersWrapper';
